/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { EonAccountIdFilters } from '../models/EonAccountIdFilters';
import { StackNameFilters } from '../models/StackNameFilters';

/**
* Filter conditions. If omitted, no filtering is applied. 
*/
export class PulumiConfigurationsFilterConditions {
  'eonAccountId'?: EonAccountIdFilters;
  'stackName'?: StackNameFilters;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "eonAccountId",
      "baseName": "eonAccountId",
      "type": "EonAccountIdFilters",
      "format": ""
    },
    {
      "name": "stackName",
      "baseName": "stackName",
      "type": "StackNameFilters",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return PulumiConfigurationsFilterConditions.attributeTypeMap;
  }

  public constructor() {
  }
}

